module.exports = __webpack_public_path__ + "img/review1.30e109b6.png";